import React, { useContext, createContext, useState } from "react";
import { useMediaQuery } from "@mui/material";

const globalContext = createContext({});

export function useGlobalContext() {
  return useContext(globalContext);
}

export function GlobalContextProvider({ children }) {
  const isMobile = useMediaQuery("max-width:769px");
  const [openMenu, setOpenMenu] = useState(false);
  const isCookyAccepted = localStorage.getItem("cookiesAccepted") === "true";
  return (
    <globalContext.Provider
      value={{ isMobile, openMenu, setOpenMenu, isCookyAccepted }}
    >
      {children}
    </globalContext.Provider>
  );
}
